export const UNTAPPD_ACCESS_TOKEN_STORAGE_KEY = 'untappdAccessToken';
export const LOGGED_IN_USER_STORAGE_KEY = 'loggedInUser';
export const LOGGED_IN_UNTAPPD_USER_STORAGE_KEY = 'loggedInUntappdUser';
